import angular from 'angular';
import template from './nativeAdPreview.jade';

export class NativeAdPreviewController {
  /* @ngInject */
  constructor() {
    this.activeNativeAdTab = 1;
  }
}

export function NativeAdPreviewComponent() {
  return {
    template,
    controller: NativeAdPreviewController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      creative: '=',
      nativeAdForm: '=',
      nativeAdMainImgUrl: '=',
      nativeAdMainVideoUrl: '=',
      nativeAdIconUrl: '='
    },
    bindToController: true,
    require: '^?creativesForm',
    link: function(scope, element, attrs, creativesFormCtrl) {
      if (creativesFormCtrl) {
        //scope.vm.variations = campaignsEditCtrl.variations;
      }
    }
  };
};

export default angular.module('app.components.campaigns.nativeAdPreview', [])
  .directive('nativeAdPreview', NativeAdPreviewComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/nativeAdPreview.js
 **/